import { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { useNavigate } from 'react-router-dom'
import WTypography from '../../../../Components/whiteTypography'

function ETransportDonut({ reports, setHeaderValue }) {
  const navigate = useNavigate()
  const [click, setClick] = useState(false)
  const [emptyReport, setEmptyReport] = useState(false)

  const [revData, setRevData] = useState({
    labels: ['Revenus salariaux', 'Revenus passifs', 'revenus autres'],
    datasets: [
      {
        data: [80, 5, 15],
        backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderWidth: 1,
        hoverOffset: 4,
        precision: 0,
      },
    ],
  })
  const optiondonut = {
    responsive: true,
    // maintainAspectRatio: false,
    aspectRatio: 1.3,
    clip: true,
    onClick: async function (evt, element) {
      if (true) {
        let percentageAmount = []
        if (click) {
          setClick(false)
          getRavData()
        } else {
          setClick(true)
          if (element.length > 0) {
            let catName = revData.labels[element[0].index]

            let data = [...reports[0].maind]
            data = data.filter((v) => v.name === catName)
            if (data.length > 0) data = data[0]
            setHeaderValue(data.value)

            let labels = []
            let amount = []

            data &&
              data.vehicles &&
              data.vehicles.map((cat, i) => {
                labels.push(cat.name)
                amount.push(cat.value)
              })
            data &&
              data.souscat &&
              data.souscat.map((cat, i) => {
                labels.push(cat.name)
                amount.push(cat.value)
              })
            // let amount =  [data.elchauf,data.elclasse,data.eleau,data.elelectro,data.elnbpers,data.elnorme,data.elsuperfi,data.eltypelog]
            let totalAmount = amount.reduce((a, b) => Math.abs(a) + Math.abs(b), 0)
            amount.map((v, i) => {
              if (v !== 0) {
                percentageAmount.push(((v * 100) / totalAmount).toFixed(0)) // removing decimal point
              }
            })

            setRevData({
              labels: labels,
              datasets: [
                {
                  data: percentageAmount,
                  backgroundColor: [
                    '#93b7ff',
                    '#6087cd',
                    '#295a9c',
                    '#6087cd',
                    '#295a9c',
                    '#6087cd',
                    '#295a9c',
                    '#6087cd',
                    '#295a9c',
                    '#6087cd',
                    '#295a9c',
                    '#6087cd',
                    '#295a9c',
                  ],
                  borderColor: [
                    '#93b7ff',
                    '#6087cd',
                    '#295a9c',
                    '#6087cd',
                    '#295a9c',
                    '#6087cd',
                    '#295a9c',
                    '#6087cd',
                    '#295a9c',
                    '#6087cd',
                    '#295a9c',
                    '#6087cd',
                    '#295a9c',
                  ],
                  borderWidth: 1,
                  hoverOffset: 4,
                  precision: 0,
                },
              ],
            })
          }
        }
      }
    },
    plugins: {
      datalabels: {
        formatter: function (value, ctx) {
          return ctx.chart.data.labels[ctx.dataIndex] + '\n' + [value + '%']
        },
        textAlign: 'center',
        color: 'white',
        anchor: 'center',
        clamp: true,
        display: 'auto',
      },

      legend: {
        display: false,
        events: [],
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }
  function getRavData() {
    let groupName = []
    let amount = []
    let percentageAmount = []

    // storing the groups
    reports.length > 0 &&
      reports[0].maind.map((cat, i) => {
        groupName.push(cat.name)
        amount.push(cat.value)
      })

    // total amount for percentage
    let totalAmount = amount.reduce((a, b) => Math.abs(a) + Math.abs(b), 0)
    if (totalAmount) {
      setEmptyReport(false)
    } else {
      setEmptyReport(true)
    }
    amount.map((v, i) => {
      if (v !== 0) {
        percentageAmount.push(((v * 100) / totalAmount).toFixed(0)) // removing decimal point
      }
    })
    groupName.length > 0 && setHeaderValue(reports[0].hadervalue)
    setRevData({
      labels: groupName,
      datasets: [
        {
          // label: "Répartition revenus",
          data: percentageAmount,
          backgroundColor: [
            '#93b7ff',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
          ],
          borderColor: [
            '#93b7ff',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
          ],
          borderWidth: 1,
          hoverOffset: 4,
          precision: 0,
        },
      ],
    })
  }
  useEffect(() => {
    getRavData()
  }, [reports])

  const RevDoughnutChart = () => (
    <>
      {/* {reports.length > 0 && reports[0].maind.length === 0 ? ( */}
      {emptyReport ? (
        <WTypography variant="h6" align="center" marginTop="10rem">
          Aucune donnée
        </WTypography>
      ) : (
        <Doughnut data={revData} options={optiondonut} />
      )}
    </>
  )

  return (
    <>
      <RevDoughnutChart />
    </>
  )
}

export default ETransportDonut
